export function Icon({ height, width, color, color2 }: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width || '100%'} height={height || '100%'} viewBox="0 0 512.000000 512.000000">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" stroke="none">
                <linearGradient id={`gradient-${color}`} x1="0" x2="0" y1="0" y2="1">
                    <stop offset="0%" stopColor={color} />
                    <stop offset="100%" stopColor={color2 ?? color} />
                </linearGradient>
                <path fill={`url(#gradient-${color})`} d="M1834 5101 c-108 -31 -225 -125 -274 -220 -53 -104 -50 -12 -50
-1788 l0 -1643 -62 0 c-73 0 -117 -22 -148 -72 -18 -31 -20 -51 -20 -280 l0
-248 -42 0 c-125 0 -202 -131 -135 -231 40 -60 72 -69 250 -69 l157 0 0 -124
0 -123 -44 -5 c-150 -17 -186 -218 -51 -282 30 -15 66 -17 254 -14 241 3 245
4 295 72 29 38 29 114 0 153 -31 42 -83 73 -120 73 l-34 0 0 125 0 125 750 0
750 0 0 -125 0 -125 -31 0 c-71 0 -149 -79 -149 -150 0 -44 38 -105 79 -128
36 -21 51 -22 250 -22 191 0 216 2 250 20 43 21 81 85 81 134 0 70 -78 146
-150 146 l-30 0 0 125 0 125 158 0 c177 0 209 9 249 69 67 100 -10 231 -134
231 l-43 0 0 248 c0 229 -2 249 -20 280 -31 50 -75 72 -147 72 l-63 0 0 1644
c0 1586 -1 1646 -19 1705 -70 225 -295 358 -523 310 -122 -26 -248 -121 -302
-227 -58 -114 -56 -72 -56 -1243 l0 -1076 -22 -33 c-37 -54 -73 -75 -128 -75
-55 0 -91 21 -127 75 l-23 33 0 1076 c0 1166 2 1129 -54 1239 -94 185 -319
281 -522 223z m196 -303 c18 -13 43 -36 54 -51 21 -28 21 -32 26 -1135 4 -767
9 -1116 16 -1137 63 -172 193 -285 364 -316 222 -39 446 109 506 336 11 40 14
259 14 1124 0 1054 0 1075 20 1116 53 110 212 111 264 1 15 -31 16 -181 16
-1660 l0 -1626 -750 0 -750 0 2 1638 3 1637 22 31 c45 63 133 82 193 42z
m1510 -3798 l0 -150 -980 0 -980 0 0 150 0 150 980 0 980 0 0 -150z"/>
            </g>
        </svg>
    );
}